import { useCallback, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useSyncedForm, withDefaults } from "@/hooks/settings/useSettingsDoc";
import { saveWithToast, withoutEmpty } from "@/hooks/settings/saveWithToast";

const graphForm = (data) => ({ ...withDefaults(data?.graph, { tenant_id: "", client_id: "" }), client_secret: "" });

export function useGraphSettings(settings, reload) {
  const [graph, setGraph] = useSyncedForm(settings, graphForm);
  const [testResult, setTestResult] = useState(null);
  const [testing, setTesting] = useState(false);

  const saveGraph = useCallback(() => saveWithToast(
    () => api.put("/settings/graph", withoutEmpty(graph, "client_secret")),
    "Credenciales Graph actualizadas", reload,
  ), [graph, reload]);

  const testGraph = useCallback(async () => {
    setTesting(true); setTestResult(null);
    try {
      const { data } = await api.post("/settings/graph/test");
      setTestResult(data);
      if (data.ok) toast.success(`Conexión exitosa: ${data.organization}`);
      else toast.error(data.error || "Fallo en la conexión");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
    } finally { setTesting(false); }
  }, []);

  return { graph, setGraph, testResult, testing, saveGraph, testGraph };
}
